<template>
    <div>
    <div class="content" :class="{ 'fade-out': isFading }">
        <div class="floating-circle circle1"></div>
        <div class="floating-circle circle2"></div>
        <div class="floating-circle circle3"></div>
        <div class="floating-circle circle4"></div>
        <div class="floating-circle circle5"></div>

        <h1 class="welcome-text">Welcome</h1>
        </div>
        
        <!-- 协议弹窗 -->
        <Agreement 
            :visible="showAgreementModal" 
            :agreement-data="agreementData"
            @agree="handleAgreementAgree"
            @disagree="handleAgreementDisagree"
        />
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import request from '@/utils/request'
import Agreement from './Agreement.vue'

export default {
    name: 'WelcomeView',
    components: {
        Agreement
    },
    emits: ['transition-complete'],
    setup(props, { emit }) {
        const isFading = ref(false)
        const requestResult = ref(null)
        const historyMessages = ref([])  // 添加历史消息存储
        const showAgreementModal = ref(false)  // 控制协议弹窗显示
        const agreementData = ref({  // 协议内容
            user_agreement: '',
            privacy_policy: ''
        })
        let particleInterval

        const createParticle = () => {
            const particle = document.createElement('div')
            particle.className = 'particle'
            particle.style.left = Math.random() * 100 + '%'
            particle.style.animationDuration = (Math.random() * 3 + 2) + 's'
            document.querySelector('.content').appendChild(particle)

            setTimeout(() => {
                particle.remove()
            }, 5000)
        }

        // 处理历史消息
        const processHistoryMessages = (messages) => {
            return messages
                .filter(msg => msg.isSuccess === 1)  // 只保留成功的消息
                .map(msg => {
                    // 构建用户消息
                    const userMsg = buildUserMessage(msg)
                    // 构建AI回复消息
                    const aiMsg = buildAIMessage(msg)
                    
                    return [userMsg, aiMsg].filter(Boolean)  // 过滤掉空消息
                })
                .flat()  // 扁平化数组
        }

        // 构建用户消息
        const buildUserMessage = (msg) => {
            switch (msg.type) {
                case 0: // 文本
                    return {
                        type: 'text',
                        text: msg.content,
                        isUser: true
                    }
                case 1: // 图片
                    return {
                        type: 'image',
                        url: msg.imageUrl,
                        isUser: true
                    }
                case 2: // 图文
                    return {
                        type: 'mixed',
                        text: msg.content,
                        images: [msg.imageUrl],
                        isUser: true
                    }
                case 3: // 语音
                    return {
                        type: 'voice',
                        url: msg.audioUrl,
                        isUser: true
                    }
                default:
                    return null
            }
        }

        // 构建AI回复消息
        const buildAIMessage = (msg) => {
            // 将feedback数字转换为字符串，并设置feedbackValue
            // feedback: 1=点赞, 2=点踩 -> 转换为 'like'/'dislike'
            let feedbackStr = null;
            let feedbackValue = msg.feedback || 0;
            if (msg.feedback === 1) {
                feedbackStr = 'like';
            } else if (msg.feedback === 2) {
                feedbackStr = 'dislike';
            }
            
            if (msg.isTTS === 1) {
                // AI语音回复
                return {
                    type: 'voice',
                    url: msg.aiAudioUrl,
                    text: msg.aiResponse,
                    isUser: false,
                    userMessageId: msg.timestamp,
                    feedback: feedbackStr,        // 字符串格式：'like'/'dislike'/null
                    feedbackValue: feedbackValue, // 数字格式：1/2/0
                    suggest: msg.suggest || '',
                    isSuccess: msg.isSuccess,
                    fk: msg.fk ?? 0
                }
            } else {
                // AI文字回复
                return {
                    type: 'text',
                    text: msg.aiResponse,
                    isUser: false,
                    userMessageId: msg.timestamp,
                    feedback: feedbackStr,        // 字符串格式：'like'/'dislike'/null
                    feedbackValue: feedbackValue, // 数字格式：1/2/0
                    suggest: msg.suggest || '',
                    isSuccess: msg.isSuccess,
                    fk: msg.fk ?? 0
                }
            }
        }

        // // 检查用户状态
        // const checkUserState = async () => {
        //     try {
        //         console.log('开始检查用户状态...')
        //         const response = await request.get('/message/check-session')
        //         console.log('接口返回结果:', response)
                
        //         // 保存会话ID（只在需要时更新）
        //         console.log(response)
        //         if (response.data && response.data.conversationId && response.data.conversationId.trim()) {
        //             const currentId = localStorage.getItem('conversationId')
        //             const newId = response.data.conversationId
        //             // 只有当ID不同或不存在时才更新
        //             if (currentId !== newId) {
        //                 localStorage.setItem('conversationId', newId)
        //                 //console.log('更新会话ID:', newId)
        //             }
        //         }
                
        //         // 根据返回结果决定状态
        //         if (response.code === 1) {
        //             // 返回1：有历史会话，处理历史消息
        //             const processedMessages = processHistoryMessages(response.data.messages)
        //             historyMessages.value = processedMessages
        //             console.log('处理后的历史消息:', processedMessages)
                    
        //             requestResult.value = 'chatting'
        //             console.log('有历史会话，将进入聊天页面')
        //         } else {
        //             // 返回0：无历史会话，进入介绍页面
        //             requestResult.value = 'intro'
        //             console.log('无历史会话，将进入介绍页面')
        //         }
        //     } catch (error) {
        //         console.error('状态检查失败:', error)
        //         // 请求失败时默认进入介绍页面
        //         requestResult.value = 'intro'
        //     }
        // }
        // 新增：在调用check-session3之前清理localStorage
        const clearLocalStorageBeforeCheckSession = () => {
            // 清理Dify AI会话信息
            localStorage.removeItem('aiConversationId');
            localStorage.removeItem('aiMessageId');
            
            // 清理分页信息
            localStorage.removeItem('hasMoreHistory');
            localStorage.removeItem('nextQueryTimestamp');
            
            console.log('Welcome页面加载，清理AI会话和分页信息，保留conversationId');
        };

        // 获取协议内容
        const fetchAgreements = async () => {
            // 根据浏览器语言决定参数：0-中文，1-英文
            const browserLang = navigator.language.startsWith('zh') ? 0 : 1
            console.log('获取协议内容，语言参数:', browserLang)
            
            const response = await request.get('/tenant/agreements', {
                params: { lang: browserLang }
            })
            
            if (response.code === 200 && response.data) {
                agreementData.value = {
                    user_agreement: response.data.user_agreement || '',
                    privacy_policy: response.data.privacy_policy || ''
                }
                console.log('协议内容获取成功')
            }
        }
        
        // 显示协议弹窗（返回 Promise，等待用户操作）
        const showAgreementModalAsync = () => {
            return new Promise((resolve) => {
                showAgreementModal.value = true
                
                // 存储 resolve 函数，供按钮点击时调用
                window.__agreementResolve = resolve
            })
        }
        
        // 处理用户同意协议
        const handleAgreementAgree = (consent) => {
            console.log('用户同意协议，consent:', consent)
            // 保存同意状态到 localStorage
            localStorage.setItem('agreement_consent', '0')
            showAgreementModal.value = false
            
            // 调用 resolve，继续执行后续流程
            if (window.__agreementResolve) {
                window.__agreementResolve(0) // 0 表示同意
                window.__agreementResolve = null
            }
        }
        
        // 处理用户不同意协议
        const handleAgreementDisagree = (consent) => {
            console.log('用户不同意协议，consent:', consent)
            // 保存不同意状态到 localStorage
            localStorage.setItem('agreement_consent', '1')
            showAgreementModal.value = false
            
            // 调用 resolve，停止流程
            if (window.__agreementResolve) {
                window.__agreementResolve(1) // 1 表示不同意
                window.__agreementResolve = null
            }
            
            // 显示提示信息（根据浏览器语言）
            const browserLang = navigator.language || navigator.userLanguage || navigator.browserLanguage
            const isChinese = browserLang.toLowerCase().startsWith('zh')
            const message = isChinese 
                ? '您需要同意用户协议和隐私政策才能使用本服务' 
                : 'You need to agree to the User Agreement and Privacy Policy to use this service'
            alert(message)
        }

        // 检查用户状态
        const checkUserState = async () => {
            try {
                console.log('开始检查用户状态...')
                
                // 新增：在调用check-session3之前，清理相关的localStorage数据
                // 暂时不清理 原因清理之后如果有对话 AI会话信息会丢失 导致没有记忆功能
                //clearLocalStorageBeforeCheckSession();

                // 获取介绍页面配置
                await fetchIntroConfig();
                
                // ========== 协议弹窗逻辑 ==========
                // 1. 判断是否需要弹窗
                const oldConversationId = localStorage.getItem('conversationId')
                const agreementConsent = localStorage.getItem('agreement_consent')
                // 修改：如果用户不同意（'1'），也需要弹窗
                const needAgreement = !oldConversationId || !agreementConsent || agreementConsent === '1'
                
                if (needAgreement) {
                    console.log('需要显示协议弹窗')
                    // 2. 获取协议内容
                    await fetchAgreements()
                    // 3. 显示弹窗，等待用户操作
                    const consent = await showAgreementModalAsync()
                    
                    // 4. 如果用户不同意，停止流程
                    if (consent === 1) {
                        console.log('用户不同意协议，停止流程')
                        return
                    }
                    // 5. 用户同意，继续执行
                    console.log('用户同意协议，继续流程')
                }
                // ========== 协议弹窗逻辑结束 ==========
                
                // 在调用 check-session3 之前，再次检查协议状态
                // 如果 agreement_consent 不是 '0'（同意），都需要阻止
                const finalAgreementConsent = localStorage.getItem('agreement_consent')
                if (!finalAgreementConsent || finalAgreementConsent !== '0') {
                    console.log('用户未同意协议或协议状态异常，阻止调用 check-session3')
                    return
                }
                
                // 获取同意状态（用于传递给后端）
                // const agreementConsentValue = localStorage.getItem('agreement_consent') || '0'
                
                // 调用 check-session3，传递同意参数
                // 注释：前端已强制要求同意，后端默认保存为同意，不需要传递参数
                const response = await request.get('/message/check-session3')
                // const response = await request.get('/message/check-session3', {
                //     params: {
                //         agreement_consent: agreementConsentValue
                //     }
                // })
                console.log('接口返回结果:', response)
                
                // 保存会话ID（只在需要时更新）
                if (response.data && response.data.conversationId && response.data.conversationId.trim()) {
                    const currentId = localStorage.getItem('conversationId')
                    const newId = response.data.conversationId
                    // 只有当ID不同或不存在时才更新
                    if (currentId !== newId) {
                        localStorage.setItem('conversationId', newId)
                    }
                }
               
                            // 根据返回结果决定状态
                if (response.data.code === 1) {
                    
                    // 返回1：有历史会话，处理历史消息
                    const processedMessages = processHistoryMessages(response.data.messages)
                    historyMessages.value = processedMessages
                    console.log('处理后的历史消息:', processedMessages)
                    //requestResult.value = 'chatting'
                    // 处理分页信息
                    if (response.data.hasMoreHistory) {
                        console.log('还有更多历史数据，下次查询时间戳:', response.data.nextQueryTimestamp)
                        // 将分页信息存储到localStorage，供chatting页面使用
                        localStorage.setItem('hasMoreHistory', 'true')
                        localStorage.setItem('nextQueryTimestamp', response.data.nextQueryTimestamp)
                    } else {
                        localStorage.setItem('hasMoreHistory', 'false')
                        localStorage.setItem('nextQueryTimestamp', '')
                    }
                    
                    
                    //alert(requestResult.value)
                    console.log('有历史会话，将进入聊天页面')
                    
                    // 在进入 Chatting 之前，再次检查协议状态
                    // 如果 agreement_consent 不是 '0'（同意），都需要阻止
                    const agreementConsentBeforeChatting = localStorage.getItem('agreement_consent')
                    if (!agreementConsentBeforeChatting || agreementConsentBeforeChatting !== '0') {
                        console.log('用户未同意协议或协议状态异常，阻止进入 Chatting 页面')
                        return
                    }
                    
                    emit('transition-complete', 'chatting')
                } else {
                    // 返回0：无历史会话，进入介绍页面
                    // 清除分页信息
                    localStorage.setItem('hasMoreHistory', 'false')
                    localStorage.setItem('nextQueryTimestamp', '')
                    
                   // requestResult.value = 'intro'
                    console.log('无历史会话，将进入介绍页面')
                    
                    // 在进入 Intro 之前，再次检查协议状态
                    // 如果 agreement_consent 不是 '0'（同意），都需要阻止
                    const agreementConsentBeforeIntro = localStorage.getItem('agreement_consent')
                    if (!agreementConsentBeforeIntro || agreementConsentBeforeIntro !== '0') {
                        console.log('用户未同意协议或协议状态异常，阻止进入 Intro 页面')
                        return
                    }
                    
                    emit('transition-complete', 'intro')
                }
            } catch (error) {
                console.error('状态检查失败:', error)
                // 请求失败时默认进入介绍页面，清除分页信息
                localStorage.setItem('hasMoreHistory', 'false')
                localStorage.setItem('nextQueryTimestamp', '')
                //requestResult.value = 'intro'
                emit('transition-complete', 'intro')
            }
        }
        // 新增：获取Intro配置
        // const fetchIntroConfig = async () => {
        //     try {
        //         console.log('开始获取所有语言配置...');
                
        //         // 并行获取中英文配置
        //         const [zhResponse, enResponse] = await Promise.all([
        //             request.get('/webconfig/intro', { params: { language: 'zh' } }),
        //             request.get('/webconfig/intro', { params: { language: 'en' } })
        //         ]);
                
        //         if (zhResponse.data && zhResponse.code === 200 && 
        //             enResponse.data && enResponse.code === 200) {
                    
        //             const allConfigs = {
        //                 zh: zhResponse.data,
        //                 en: enResponse.data
        //             };
                    
        //             // 保存所有语言配置
        //             localStorage.setItem('allIntroConfigs', JSON.stringify(allConfigs));
                    
        //             // 设置当前语言
        //             const currentLang = getBrowserLanguage();
        //             localStorage.setItem('currentLanguage', currentLang);
                    
        //             console.log('获取所有语言配置成功:', allConfigs);
        //         } else {
        //             throw new Error('配置获取失败');
        //         }
        //     } catch (error) {
        //         console.error('获取配置失败:', error);
        //         // 使用默认配置
        //         const defaultConfigs = {
        //             zh: getDefaultConfig('zh'),
        //             en: getDefaultConfig('en')
        //         };
        //         localStorage.setItem('allIntroConfigs', JSON.stringify(defaultConfigs));
        //     }
        // }


        // // 默认配置（降级使用）
        // const getDefaultConfig = (language) => {
        //     if (language === 'zh') {
        //         return {
        //             logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
        //             title: '我是捷昌驱动智能客服,很高兴见到你！',
        //             description: '捷昌驱动,科技驱动智慧生活。我可以为您提供产品咨询、技术支持、售后服务等帮助，请把您的问题告诉我吧～',
        //             input_placeholder: '请输入您的问题，我将为您提供专业帮助'
        //         };
        //     } else {
        //         return {
        //             logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
        //             title: 'I am Jiecang Drive intelligent customer service, nice to meet you!',
        //             description: 'Jiecang Drive, technology drives smart life. I can provide you with product consultation, technical support, after-sales service and other assistance. Please tell me your questions～',
        //             input_placeholder: 'Send message to Jiecang customer service assistant'
        //         };
        //     }
        // }

        // // 获取浏览器语言
        // const getBrowserLanguage = () => {
        // const browserLang = navigator.language || navigator.userLanguage;
        // return browserLang.startsWith('zh') ? 'zh' : 'en';
        // }

        // 使用公司LOGO作为页面 Favicon
        const setFavicon = (url) => {
            if (!url) return;
            let link = document.querySelector('link[rel="icon"]');
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = url;
        };

        // 改进的配置获取函数
        const fetchIntroConfig = async () => {
            try {
                console.log('开始获取所有语言配置...');
                
                // 使用新的统一接口获取所有语言配置
                const response = await request.get('/webconfig/config', { 
                    params: { key: 'intro_config' } 
                });
                
                if (response.data && response.code === 200) {
                    const allConfigs = response.data;
                    
                    // 保存所有语言配置到localStorage
                    localStorage.setItem('allIntroConfigs', JSON.stringify(allConfigs));
                    
                    // 使用公司LOGO作为页面 Favicon（各语言 logo 相同，任取其一）
                    const logoUrl = allConfigs.zh?.logo || allConfigs.en?.logo || (allConfigs[Object.keys(allConfigs)[0]]?.logo);
                    if (logoUrl) setFavicon(logoUrl);
                    
                    // 检测浏览器语言并设置
                    const currentLang = getBrowserLanguage();
                    localStorage.setItem('currentLanguage', currentLang);
                    
                    console.log('获取所有语言配置成功:', allConfigs);
                    console.log('当前语言:', currentLang);
                } else {
                    throw new Error('配置获取失败');
                }
            } catch (error) {
                console.error('获取配置失败:', error);
                // 使用默认配置作为降级方案
                const defaultConfigs = getDefaultAllLanguageConfigs();
                localStorage.setItem('allIntroConfigs', JSON.stringify(defaultConfigs));
                if (defaultConfigs.zh?.logo) setFavicon(defaultConfigs.zh.logo);
                
                // 设置默认语言
                const currentLang = getBrowserLanguage();
                localStorage.setItem('currentLanguage', currentLang);
            }
        }
        // 完整的默认多语言配置
        const getDefaultAllLanguageConfigs = () => {
            return {
                zh: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: '我是捷昌驱动智能客服,很高兴见到你！',
                    description: '捷昌驱动,科技驱动智慧生活。我可以为您提供产品咨询、技术支持、售后服务等帮助，请把您的问题告诉我吧～',
                    input_placeholder: '请输入您的问题'
                },
                en: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: 'I am Jiecang Drive intelligent customer service, nice to meet you!',
                    description: 'Jiecang Drive, technology drives smart life. I can provide you with product consultation, technical support, after-sales service and other assistance. Please tell me your questions～',
                    input_placeholder: 'Send message to Jiecang customer service assistant'
                },
                de: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: 'Ich bin der intelligente Kundenservice von Jiecang Drive, schön Sie kennenzulernen!',
                    description: 'Jiecang Drive, Technologie treibt das intelligente Leben an. Ich kann Ihnen bei Produktberatung, technischem Support, Kundendienst und anderen Hilfestellungen behilflich sein. Teilen Sie mir Ihre Fragen mit～',
                    input_placeholder: 'Senden Sie eine Nachricht an den Jiecang Kundenservice-Assistenten'
                },
                fr: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: 'Je suis le service client intelligent de Jiecang Drive, ravi de vous rencontrer !',
                    description: 'Jiecang Drive, la technologie propulse la vie intelligente. Je peux vous fournir des conseils produits, un support technique, un service après-vente et d\'autres aides. Veuillez me dire vos questions～',
                    input_placeholder: 'Envoyez un message à l\'assistant client Jiecang'
                },
                ja: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: '私は捷昌ドライブのインテリジェントカスタマーサービスです。お会いできて嬉しいです！',
                    description: '捷昌ドライブ、テクノロジーがスマートライフを推進します。製品相談、技術サポート、アフターサービスなどのお手伝いができます。ご質問をお聞かせください～',
                    input_placeholder: '捷昌カスタマーサービスアシスタントにメッセージを送信'
                },
                it: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: 'Sono il servizio clienti intelligente di Jiecang Drive, felice di incontrarti!',
                    description: 'Jiecang Drive, la tecnologia guida la vita intelligente. Posso fornirti consulenza sui prodotti, supporto tecnico, servizio post-vendita e altri aiuti. Per favore dimmi le tue domande～',
                    input_placeholder: 'Invia un messaggio all\'assistente clienti Jiecang'
                },
                pt: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: 'Sou o atendimento ao cliente inteligente da Jiecang Drive, prazer em conhecê-lo!',
                    description: 'Jiecang Drive, tecnologia impulsiona a vida inteligente. Posso fornecer consultoria de produtos, suporte técnico, serviço pós-venda e outras assistências. Por favor, me conte suas perguntas～',
                    input_placeholder: 'Envie uma mensagem para o assistente de atendimento Jiecang'
                },
                ko: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: '저는 지창드라이브 지능형 고객 서비스입니다. 만나서 반갑습니다!',
                    description: '지창드라이브, 기술이 스마트 라이프를 이끕니다. 제품 상담, 기술 지원, 애프터 서비스 등의 도움을 드릴 수 있습니다. 질문을 알려주세요～',
                    input_placeholder: '지창 고객 서비스 어시스턴트에게 메시지 보내기'
                },
                es: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: '¡Soy el servicio al cliente inteligente de Jiecang Drive, encantado de conocerte!',
                    description: 'Jiecang Drive, la tecnología impulsa la vida inteligente. Puedo brindarte consultoría de productos, soporte técnico, servicio post-venta y otra asistencia. Por favor, cuéntame tus preguntas～',
                    input_placeholder: 'Enviar mensaje al asistente de servicio al cliente Jiecang'
                },
                ru: {
                    logo: 'https://hruiexample.oss-cn-hangzhou.aliyuncs.com/jc.png',
                    title: 'Я интеллектуальный клиентский сервис Jiecang Drive, рад познакомиться!',
                    description: 'Jiecang Drive, технологии движут умной жизнью. Я могу предоставить консультации по продуктам, техническую поддержку, послепродажное обслуживание и другую помощь. Пожалуйста, расскажите мне о ваших вопросах～',
                    input_placeholder: 'Отправить сообщение помощнику клиентского сервиса Jiecang'
                }
            };
        }
        // 改进的浏览器语言检测函数
        const getBrowserLanguage = () => {
            const browserLang = navigator.language || navigator.userLanguage || navigator.browserLanguage;
            const language = browserLang.toLowerCase();
            
            // 支持的语言映射
            const languageMap = {
                'zh': 'zh', 'en': 'en', 'de': 'de', 'fr': 'fr', 'ja': 'ja',
                'it': 'it', 'pt': 'pt', 'ko': 'ko', 'es': 'es', 'ru': 'ru'
            };
            
            // 检测语言
            for (const [code, lang] of Object.entries(languageMap)) {
                if (language.startsWith(code)) {
                    return lang;
                }
            }
            
            // 默认返回英文
            return 'en';
        }


        const getRequestResult = () => {
            //alert(requestResult.value)//输出的是null
            return requestResult.value || 'intro' // 如果请求还没完成，默认intro
        }

        const getHistoryMessages = () => {
            return historyMessages.value
        }

        onMounted(() => {
            // 立即开始请求
            checkUserState()
            
            // 每隔一段时间创建新的粒子
            particleInterval = setInterval(createParticle, 800)

            // 2秒后开始淡出
            setTimeout(() => {
                isFading.value = true
            }, 2000)

            // 2.5秒后触发过渡完成事件，根据请求结果决定进入哪个状态
            // setTimeout(() => {
            //     const targetState = getRequestResult()
            //     console.log('动画完成，进入状态:', targetState)
            //     emit('transition-complete', targetState)
            // }, 2500)

            // 2秒后停止创建粒子
            setTimeout(() => {
                clearInterval(particleInterval)
            }, 2000)

            // 添加触摸交互效果
            const content = document.querySelector('.content')
            content.addEventListener('touchstart', handleTouchStart)
            content.addEventListener('touchend', handleTouchEnd)

            // 添加设备方向感应效果
            if (window.DeviceOrientationEvent) {
                window.addEventListener('deviceorientation', handleDeviceOrientation)
            }
        })

        onUnmounted(() => {
            clearInterval(particleInterval)
            const content = document.querySelector('.content')
            if (content) {
                content.removeEventListener('touchstart', handleTouchStart)
                content.removeEventListener('touchend', handleTouchEnd)
            }
            if (window.DeviceOrientationEvent) {
                window.removeEventListener('deviceorientation', handleDeviceOrientation)
            }
        })

        const handleTouchStart = () => {
            const circles = document.querySelectorAll('.floating-circle')
            circles.forEach(circle => {
                circle.style.animationDuration = '3s'
            })
        }

        const handleTouchEnd = () => {
            const circles = document.querySelectorAll('.floating-circle')
            circles.forEach(circle => {
                circle.style.animationDuration = '6s'
            })
        }

        const handleDeviceOrientation = (e) => {
            const circles = document.querySelectorAll('.floating-circle')
            const tiltX = e.gamma / 90
            const tiltY = e.beta / 90

            circles.forEach((circle, index) => {
                const multiplier = (index + 1) * 0.5
                circle.style.transform = `translate(${tiltX * 10 * multiplier}px, ${tiltY * 10 * multiplier}px)`
            })
        }

        return {
            isFading,
            getHistoryMessages, // 暴露历史消息函数
            showAgreementModal,
            agreementData,
            handleAgreementAgree,
            handleAgreementDisagree
        }
    }
}
</script>

<style scoped>
.content {
    width: 100%;
    height: 100vh;
    position: relative;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    padding-top: 15vh;
    transition: opacity 0.5s ease-out;
}

.content.fade-out {
    opacity: 0;
}

.welcome-text {
    font-size: 52px;
    font-weight: 500;
    color: #1a1a1a;
    letter-spacing: -0.02em;
    z-index: 10;
    position: relative;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.floating-circle {
    position: absolute;
    border-radius: 50%;
    opacity: 0.6;
    filter: blur(1px);
    animation: float 6s ease-in-out infinite;
}

.circle1 {
    width: 120px;
    height: 120px;
    background: radial-gradient(circle, rgba(233, 228, 250, 0.6) 0%, rgba(233, 228, 250, 0.2) 100%);
    top: 15%;
    left: 10%;
    animation-delay: 0s;
}

.circle2 {
    width: 100px;
    height: 100px;
    background: radial-gradient(circle, rgba(221, 213, 247, 0.7) 0%, rgba(221, 213, 247, 0.3) 100%);
    top: 25%;
    right: 15%;
    animation-delay: -2s;
}

.circle3 {
    width: 90px;
    height: 90px;
    background: radial-gradient(circle, rgba(206, 191, 242, 0.7) 0%, rgba(206, 191, 242, 0.3) 100%);
    top: 50%;
    left: 60%;
    animation-delay: -1.5s;
}

.circle4 {
    width: 110px;
    height: 110px;
    background: radial-gradient(circle, rgba(186, 164, 235, 0.8) 0%, rgba(186, 164, 235, 0.4) 100%);
    bottom: 35%;
    left: 20%;
    animation-delay: -1s;
}

.circle5 {
    width: 130px;
    height: 130px;
    background: radial-gradient(circle, rgba(145, 112, 210, 0.9) 0%, rgba(145, 112, 210, 0.5) 100%);
    bottom: 15%;
    right: 10%;
    animation-delay: -3s;
}

.particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 50%;
    animation: particle 4s linear infinite;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0px) translateX(0px) scale(1);
    }

    25% {
        transform: translateY(-20px) translateX(10px) scale(1.1);
    }

    50% {
        transform: translateY(-10px) translateX(-15px) scale(0.9);
    }

    75% {
        transform: translateY(-25px) translateX(5px) scale(1.05);
    }
}

@keyframes particle {
    0% {
        opacity: 0;
        transform: translateY(100vh) scale(0);
    }

    10% {
        opacity: 1;
    }

    90% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        transform: translateY(-100px) scale(1);
    }
}
</style>